import React from 'react';
import { Heading } from '../../Heading/Heading';
import { HeadingProps } from '../../../../types/HtmlProps';
import { appendClassName } from '../../../../lib/bemUtils/classname';

type AccordionHeadingProps = HeadingProps & {
  hierarchy?: number;
  ref?: React.RefObject<HTMLHeadingElement>;
};

export function AccordionHeading({ hierarchy = 3, children, className, ref, ...props }: AccordionHeadingProps) {
  return (
    <Heading hierarchy={hierarchy} className={appendClassName(className, 'accordion__category')} {...props} ref={ref}>
      {children}
    </Heading>
  );
}
